import React from "react";
import styles from "../styles/Services.module.css";
import { motion } from "framer-motion";
import Idea from "../img/Idea.svg";
import Turnaround from "../img/Turn-around.svg";
import strategy from "../img/Strategy.svg";
import Business from "../img/Business.svg";
import Risk from "../img/Risk.svg";
import Corporate from "../img/Corporate.svg";

const Services = () => {
  const cards = [
    {
      img: Idea,
      title: "Business Launch & Start-ups",
      desc: "Expert guidance in launching new businesses and nurturing start-ups from concept to successful market entry.",
    },
    {
      img: Turnaround,
      title: "Business Turnaround",
      desc: "Strategic interventions to revitalize underperforming businesses and restore profitability.",
    },
    {
      img: strategy,
      title: "Strategy Redefinition",
      desc: "Comprehensive strategic planning and market repositioning to align with evolving business landscapes.",
    },
    {
      img: Business,
      title: "Business Management",
      desc: "Operational excellence and management consulting for established businesses seeking growth.",
    },
    {
      img: Risk,
      title: "Risk Management Advisory",
      desc: "Specialized risk assessment and management solutions for corporate clients across industries.",
    },
    {
      img: Corporate,
      title: "Corporate Advisory",
      desc: "Strategic advisory services tailored to diverse corporate needs and industry-specific challenges.",
    },
  ];

  const cardVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: i * 0.2 },
    }),
  };

  return (
    <div id="services" className={styles.service_cont}>
      <h1>Our Services</h1>
      <p>
        Comprehensive management consultancy services designed to drive <br />
        sustainable growth and transformation
      </p>
      <div className={styles.stands_grid}>
        {cards.map((c, i) => (
          <motion.div
            key={i}
            className={styles.stand_grid1}
            custom={i}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={cardVariant}
            whileHover={{ scale: 1.05, boxShadow: "0 8px 20px rgba(0,0,0,0.15)" }}
          >
            <div>
              <img src={c.img} alt={c.title} />
            </div>
            <h2>{c.title}</h2>
            <p>{c.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Services;
